// import httpClient from "./httpClient";
import fileDownload from 'js-file-download';
import axios from "axios";

const  getReport = (params) =>
    axios({
        url: `${process.env.VUE_APP_BASE_URL}/record/time-report/`,
        data: params,
        method: 'POST',
        responseType: 'blob', // Important
        headers: {
            "Authorization" :  "Token " + localStorage.getItem('token')
        }
    }).then((response)=> {
        fileDownload(response.data, `file-report:from_date=${params.from_date}&to_date=${params.to_date}.xlsx`);
    }).catch((e)=>console.log('error',e))


const  getReportForAdmin = (params) =>
    axios({
        url: `${process.env.VUE_APP_BASE_URL}/record/time-report-for-admin/`,
        data: params,
        method: 'POST',
        responseType: 'blob', // Important
        headers: {
            "Authorization" :  "Token " + localStorage.getItem('token')
        }
    }).then((response)=> {
        fileDownload(response.data, `file-report:from_date=${params.from_date}&to_date=${params.to_date}.xlsx`);
    }).catch((e)=>console.log('error',e))




// const getReport = (params) => httpClient.get(`/record/file-report/`,{
//         headers: {responseType: 'blob'},
//         params: {
//             params:params
//         },
//     }
// )



export {
    getReport,
    getReportForAdmin
}
